import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M169.411765,1355.41176 C262.814118,1355.41176 338.823529,1431.42118 338.823529,1524.82353 C338.823529,1618.22588 262.814118,1694.23529 169.411765,1694.23529 C76.0094118,1694.23529 0,1618.22588 0,1524.82353 C0,1431.42118 76.0094118,1355.41176 169.411765,1355.41176 Z M1920,1468.35294 L1920,1581.29412 L564.705882,1581.29412 L564.705882,1468.35294 L1920,1468.35294 Z M169.411765,790.705882 C262.814118,790.705882 338.823529,866.715294 338.823529,960.117647 C338.823529,1053.52 262.814118,1129.52941 169.411765,1129.52941 C76.0094118,1129.52941 0,1053.52 0,960.117647 C0,866.715294 76.0094118,790.705882 169.411765,790.705882 Z M1920,903.647059 L1920,1016.58824 L564.705882,1016.58824 L564.705882,903.647059 L1920,903.647059 Z M169.411765,226 C262.814118,226 338.823529,302.009412 338.823529,395.411765 C338.823529,488.814118 262.814118,564.823529 169.411765,564.823529 C76.0094118,564.823529 0,488.814118 0,395.411765 C0,302.009412 76.0094118,226 169.411765,226 Z M1920,338.941176 L1920,451.882353 L564.705882,451.882353 L564.705882,338.941176 L1920,338.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBulletListLine = /*#__PURE__*/function (_Component) {
  _inherits(IconBulletListLine, _Component);

  var _super = _createSuper(IconBulletListLine);

  function IconBulletListLine() {
    _classCallCheck(this, IconBulletListLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconBulletListLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBulletList",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconBulletListLine.displayName = "IconBulletListLine";
  return IconBulletListLine;
}(Component);

IconBulletListLine.glyphName = 'bullet-list';
IconBulletListLine.variant = 'Line';
IconBulletListLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBulletListLine;
export { IconBulletListLine };